const ERROR_PATTERNS = [
  { match: /недостаточно криптовалюты|insufficient crypto balance/i, key: "insufficientCryptoBalance" },
  { match: /недостаточно средств на балансе|insufficient funds on the balance/i, key: "insufficientFundsBalance" },
  { match: /недостаточно средств|insufficient funds|insufficient balance/i, key: "cash_null" },
  { match: /минимальная сумма вывода|minimum withdrawal/i, key: "minWithdrawAmount", extractAmount: true },
  { match: /минимальная сумма пополнения|minimum deposit/i, key: "minDepositAmount", extractAmount: true },
  { match: /минимальная сумма покупки|minimum purchase amount/i, key: "minPurchaseAmount", extractAmount: true },
  { match: /минимальная сумма продажи|minimum sale amount/i, key: "minSaleAmount", extractAmount: true },
  { match: /минимальная ставка|minimum bet/i, key: "minBet", extractAmount: true },
  { match: /некорректный номер карты|incorrect card number/i, key: "incorrectCardNumber" },
  { match: /некорректный формат криптокошелька|incorrect.*crypto wallet/i, key: "incorrectCryptoWallet" },
  { match: /некорректный номер телефона|incorrect phone/i, key: "incorrectSbpPhone" },
  { match: /вывод невозможен|withdrawal is not possible|withdrawal.*impossible/i, key: "withdrawalNotPossible" },
  { match: /пройти верификацию|pass verification/i, key: "verificationRequired" },
  { match: /заблокирован|blocked/i, key: "withdrawalBlocked" },
  { match: /реквизиты.*депозит|details used for deposit/i, key: "withdrawalDepositOnly" },
  { match: /неподдерживаемый метод|unsupported.*method/i, key: "unsupportedWithdrawMethod" },
  { match: /некорректный метод|invalid.*method/i, key: "invalidWithdrawMethod" },
  { match: /пользователь не найден|user not found/i, key: "userNotFound" },
  { match: /платеж не найден|payment not found/i, key: "paymentNotFound" },
  { match: /попробуйте снова через|try again in|too many requests/i, key: "tooManyRequests", extractTime: true },
  { match: /способ оплаты временно|payment method.*unavailable/i, key: "paymentMethodUnavailableSupport" },
  { match: /метод оплаты временно/i, key: "paymentMethodUnavailable" },
  { match: /конкурс не найден|competition not found/i, key: "competitionNotFound" },
  { match: /конкурс завершён|competition has ended/i, key: "competitionEnded" },
  { match: /уже зарегистрированы|already registered/i, key: "registrationAlready" },
  { match: /не выполнены условия|conditions not met/i, key: "registrationConditionsNotMet" },
  { match: /регистрация успешна|registration successful/i, key: "registrationSuccess" },
  { match: /актив с символом|asset with symbol/i, key: "assetNotFound", extractAmount: true },
  { match: /транзакция не удалась|transaction failed/i, key: "transactionFailed" },
  { match: /не удалось загрузить историю|transaction history failed/i, key: "transactionHistoryFailed" },
];

function extractAmount(detail) {
  const dashMatch = detail.match(/[–-]\s*(.+)$/);
  if (dashMatch) return dashMatch[1].trim();
  const isMatch = detail.match(/is\s+(.+)$/i);
  if (isMatch) return isMatch[1].trim();
  const symbolMatch = detail.match(/[«'"]?([^»'"]+)[»'"]?\s*not found$/i);
  if (symbolMatch) return symbolMatch[1].trim();
  const spaceMatch = detail.match(/(?:пополнения|вывода|ставка|покупки|продажи)\s+(.+)$/i);
  if (spaceMatch) return spaceMatch[1].trim();
  return detail;
}

function extractTime(detail) {
  const match = detail.match(/(\d+)/);
  return match ? match[1] : "5";
}

export function translateApiError(t, detail) {
  if (!detail || typeof detail !== "string") {
    return t("genericErrorLater");
  }

  const normalized = detail.replace(/\u274c|\u26a0\ufe0f/g, "").trim();

  for (const pattern of ERROR_PATTERNS) {
    if (pattern.match.test(normalized)) {
      if (pattern.extractAmount) {
        return t(pattern.key, { amount: extractAmount(normalized) });
      }
      if (pattern.extractTime) {
        return t(pattern.key, { time: extractTime(normalized) });
      }
      return t(pattern.key);
    }
  }

  return normalized;
}

export function getDateLocale(language) {
  return language === "RU" ? "ru-RU" : "en-US";
}
